import { render, staticRenderFns } from "./ActivationFile.vue?vue&type=template&id=4e75d85f&"
import script from "./ActivationFile.vue?vue&type=script&lang=js&"
export * from "./ActivationFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports